import { createAction, createSlice } from "@reduxjs/toolkit";

// Types
import { Document } from "../../@types/document";
import { DocumentStakeholder } from "../../@types/documentStakeholder";
import { Message } from "../../@types/message";
import { addDocumentComment } from "../documentUpdate/actions/addDocumentComment";
import { fetchDocumentHistory } from "./actions/fetchDocumentHistory";
import { findDocument } from "./actions/findDocument";
import { findSigners } from "./actions/findSigners";
import { markDocumentAsRead } from "./actions/markDocumentAsRead";
import { requestCorrection } from "./actions/requestCorrection";
import { signDocument } from "./actions/signDocument";

interface DocumentShowState {
  document: Document;
  signers: DocumentStakeholder[];
  findStatus: string;
  segmentSelected: string;
  signStatus: string;
  history: Message[];
  requestCorrectionStatus: string;
}

const initialState = {
  document: {},
  signers: [],
  findStatus: "initial",
  segmentSelected: "info", //"signers"
  signStatus: "",
  history: [],
  requestCorrectionStatus: "",
} as DocumentShowState;

export const setSegmentSelected = createAction<string>("SET_SEGMENT_SELECTED");
export const resetDocumentState = createAction("RESET_DOCUMENT");
export const sortDocumentSigner = createAction<[...any]>("SORT_DOCUMENT_SIGNER");
export const setSignStatus = createAction("SET_SIGN_STATUS");
export const setRequestCorrectionActionStatus = createAction(
  "SET_REQUEST_CORRECTION_ACTION_STATUS"
);

const documentSignerShowSlice = createSlice({
  name: "documentSignerShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /**
       * Find Documents
       */
      .addCase(resetDocumentState, (state) => {
        state.document = {} as Document;
        state.signers = [];
        state.findStatus = "initial";
        state.segmentSelected = "info";
      })
      .addCase(setSegmentSelected, (state, { payload }) => {
        state.segmentSelected = payload;
      })
      .addCase(setSignStatus, (state) => {
        state.signStatus = "";
      })
      .addCase(findDocument.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findDocument.fulfilled, (state, { payload }) => {
        state.document = { ...payload };
        state.findStatus = "fulfilled";
      })
      .addCase(findDocument.rejected, (state) => {
        state.findStatus = "rejected";
      })
      // Obtener firmantes
      .addCase(findSigners.pending, (state) => {
        state.signers = [];
      })
      .addCase(findSigners.fulfilled, (state, { payload }) => {
        state.signers = payload;
      })
      .addCase(findSigners.rejected, (state) => {})

      // Firmar documento
      .addCase(signDocument.pending, (state) => {
        state.signStatus = "pending";
      })
      .addCase(signDocument.fulfilled, (state, { payload }) => {
        state.signStatus = "fulfilled";
        const { documentUpdated, documentStakeholderUpdated } = payload || {};
        if (documentUpdated) {
          state.document = documentUpdated;
        }
        if (documentStakeholderUpdated) {
          state.signers = state.signers.map((item) => ({
            ...(item.id === documentStakeholderUpdated.id ? documentStakeholderUpdated : item),
          }));
        }
      })
      .addCase(signDocument.rejected, (state) => {
        state.signStatus = "rejected";
      })
      .addCase(fetchDocumentHistory.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(fetchDocumentHistory.fulfilled, (state, { payload }) => {
        state.history = [...payload];
        state.findStatus = "fulfilled";
      })
      .addCase(fetchDocumentHistory.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(setRequestCorrectionActionStatus, (state, { payload = "" }) => {
        state.requestCorrectionStatus = payload;
      })
      // Solicitar corrección
      .addCase(requestCorrection.pending, (state) => {
        state.requestCorrectionStatus = "pending";
        // state.signers = [];
      })
      .addCase(requestCorrection.fulfilled, (state, { payload }) => {
        state.document = { ...state.document, ...payload };
        state.requestCorrectionStatus = "fulfilled";
      })
      .addCase(requestCorrection.rejected, (state, { payload }) => {
        state.requestCorrectionStatus = "rejected";
      })
      .addCase(addDocumentComment.fulfilled, (state, { payload }) => {
        state.history.unshift(payload);
      })
      .addCase(markDocumentAsRead.fulfilled, (state, { payload }) => {
        state.document = payload ? payload : state.document;
      });
  },
});

export const documentSignerShow = documentSignerShowSlice.reducer;
